import { render, staticRenderFns } from "./BatchTransferGroupTable.vue?vue&type=template&id=4d42e0d0"
import script from "./BatchTransferGroupTable.vue?vue&type=script&lang=js"
export * from "./BatchTransferGroupTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports